import ApiService from '@/services/core/api.service'

const PaymentRequestService = {
  async get (query) {
    return ApiService.get(`auditor/payment-requests?${query}`)
  }
}

export default PaymentRequestService
